import { useMemo } from 'react'
import { BreadType } from 'types/bread'
import { ScheduleType } from 'types/schedule'
import { StockType } from 'types/stock'
import { TemporaryOpenDate } from 'types/calendar'

// 受付設定と在庫に変更のある商品を取得
const useConfirmBreadList = (
  breads: BreadType[],
  updatedSchedules: ScheduleType[],
  deletedStocks: StockType[],
  stocks: StockType[],
  temporaryOpenDates: TemporaryOpenDate[],
  generatedDailyStocksByDefaultDayOfWeeks: TemporaryOpenDate[]
): BreadType[] => {
  return useMemo(() => {
    if (
      !breads ||
      breads.length === 0 ||
      !updatedSchedules ||
      !deletedStocks ||
      !stocks ||
      !temporaryOpenDates ||
      !generatedDailyStocksByDefaultDayOfWeeks
    )
      return []
    return breads.filter((bread) => {
      return (
        updatedSchedules.some((schedule) => schedule.bread_ref.id === bread.bread_ref?.id) ||
        deletedStocks.some((stock) => stock.bread_ref.id === bread.bread_ref?.id) ||
        generatedDailyStocksByDefaultDayOfWeeks.some((calendar) => calendar.breadRef.id === bread.bread_ref?.id)
      )
    })
  }, [breads, updatedSchedules, deletedStocks, stocks, temporaryOpenDates, generatedDailyStocksByDefaultDayOfWeeks])
}

export default useConfirmBreadList
